let isDismissed = false;

export const isClmDataUsageBannerDismissed = (): boolean => isDismissed;

export const dismissClmDataUsageBanner = (): void => {
    isDismissed = true;
};

export const resetClmDataUsageBanner = (): void => {
    isDismissed = false;
};
